"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reference = void 0;
const Reference = (schemas, schema) => ({
    type(path) {
        return schemas.get(schema).type.bind(this)(path);
    },
    category(path) {
        return schemas.get(schema).category.bind(this)(path);
    },
    default() {
        return schemas.get(schema).default.bind(this)();
    },
    transform(path, value) {
        return schemas.get(schema).transform(path, value);
    },
    enabled(path) {
        return schemas.get(schema).enabled.bind(this)(path);
    },
    keep() {
        return schemas.get(schema).keep.bind(this)();
    },
    optional() {
        return schemas.get(schema).optional.bind(this)();
    },
    navigate(path, index) {
        return schemas.get(schema).navigate.bind(this)(path, index);
    },
    pathPush(path, key) {
        return schemas.get(schema).pathPush.bind(this)(path, key);
    },
    suggest(path, value) {
        return schemas.get(schema).suggest.bind(this)(path, value);
    },
    validate(path, value, errors, options) {
        return schemas.get(schema).validate.bind(this)(path, value, errors, options);
    },
    validationOption(path) {
        return schemas.get(schema).validationOption.bind(this)(path);
    },
    hook(hook, path, ...args) {
        return schemas.get(schema).hook.bind(this)(hook, path, ...args);
    },
    activeCase(path, fallback) {
        return schemas.get(schema).activeCase.bind(this)(path, fallback);
    },
    canUpdate(path, value) {
        return schemas.get(schema).canUpdate.bind(this)(path, value);
    },
    update(path, value) {
        return schemas.get(schema).update.bind(this)(path, value);
    }
});
exports.Reference = Reference;
